"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleYearList = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const VehicleYear_1 = require("../models/VehicleYear");
const PATH = 'vehicle-years';
async function vehicleYearList(firestore) {
    const results = await firestore.list(PATH);
    const vehicles = results.map(result => (0, VehicleYear_1.vehicleYearDeserialize)(result.value, result.id));
    return (0, sortBy_1.default)(vehicles, vehicle => -vehicle.value);
}
exports.vehicleYearList = vehicleYearList;
